import React from 'react';
import { Card } from '@material-ui/core';
import { toTitleCase } from '../../../helpers/helper';
import { getApplianceName } from '../../../helpers/itemizationDataHelper';
import { WIDGETS } from '../../../constants/common';

export default function RecoItem(props){
        let app = getApplianceName(props.details.appId, props.applianceList);
        const educationCtaText = props.translations["MARKETPLACE.EDUCATION_CTA_TEXT"];
        let redeemDetails = props.details.rebatesMetaData && props.details.rebatesMetaData.redeemDetails;
        let diyEnabled = props.selfInstallEnabled || redeemDetails;
        return(
            <Card className="reco-item">
                <div className="product-info-wrapper">
                    <div className="image-container">
                        <img src={props.details.image} alt={props.details.recoTitle}/>
                    </div>
                    <div className="text-content" data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_54">
                        <div className="text-wrapper">
                            <div className="title">
                                {props.details.title}
                            </div>
                            <div className="description">
                                {props.details.description}
                            </div>
                        </div>
                        {
                            props.productEducationEnabled && props.details.ctaText &&
                            <button onClick={()=>props.handleCTAClick(props.details.recoId, props.details.link)} className="cta" data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_54" data-bg-color="color_1">{props.details.ctaText}</button>
                        }
                    </div>
                </div>
                {
                    props.productEducationEnabled && educationCtaText &&
                    <div className="cta-mobile">
                        <button className="cta" onClick={()=>props.handleCTAClick(props.details.recoId, props.details.link)} data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_54" data-bg-color="color_1">
                            {educationCtaText}
                        </button>
                    </div>
                }

                {  diyEnabled &&
                    <div className="diy-wrapper">
                        {
                            props.selfInstallEnabled &&
                            <div className="diy-item" data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_2" data-bg-color="color_59">
                                {props.translations["DASHBOARD.MARKETPLACE.SELF_INSTALL"]}: <span className={(props.details.selfInstall ? "yes" : "no")}>{props.details.selfInstall ? props.translations["DASHBOARD.COMMON.YES"]: props.translations["DASHBOARD.COMMON.NO"]}</span>
                            </div>
                        }
                        {
                            redeemDetails &&
                            <div className="diy-item rebate-item" data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_2" data-bg-color="color_59" onClick={() => props.handleCTAClick(props.details.recoId, null, redeemDetails)}>
                                {props.translations["DASHBOARD.MARKETPLACE.REBATE"]}: <span className="yes">{props.translations["DASHBOARD.MARKETPLACE.REDEEM_REBATE"]}</span>
                            </div>
                        }
                    </div>
                }

                <div className="cta-wrapper">
                    {
                        props.marketplaceCTAEnabled && props.details.purchaseLinks.length > 0 &&
                        <div className="product-cta">
                            <p className="cta-description">{props.translations["DASHBOARD.MARKETPLACE.EXPLORE_APP"].replace("${app}", app)}</p>
                            <div className="purchase-btn-wrapper">
                                {props.details.purchaseLinks.map((item, index)=>(
                                    <div key={index} className="purchase-btn" onClick={()=>props.openPurchaseLink(item.link)} data-widget-name={WIDGETS.MARKETPLACE} data-border-color="color_75">
                                        {item.logo ? <img src={item.logo} alt={item.name}/> : <div className="link-name">{toTitleCase(item.name)}</div>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                    {
                        props.marketplaceCTAEnabled && props.details.contractorLinks && props.details.contractorLinks.link &&
                        <div className="product-cta">
                            <p className="cta-description">{props.translations["DASHBOARD.MARKETPLACE.HIRE_A_PROFESSIONAL"]}</p>
                            <div className="purchase-btn-wrapper">
                                <div className="hire-professional-btn" onClick={()=>props.openPurchaseLink(props.details.contractorLinks.link)} data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_1" data-border-color="color_1">
                                    {props.details.contractorLinks.name}
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {
                    props.marketPlaceInsightEnabled && props.details.insight && props.details.insight.insightText &&
                    <div className="reco-insight-container" data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_3" data-bg-color="color_59">
                        <img src={props.insightBulbImage} alt=""/>
                        <div className="insight">
                            {props.details.insight.insightText}
                        </div>
                    </div>
                }
            </Card>
        )

}